'use memo';

import { Outlet, createFileRoute } from '@tanstack/react-router';
import { ProductLogoMediumDeal as LogoDeal } from '@/components/Logo';
import { ProductHeader } from '@/components/ProductHeader';
import { useTranslation } from '@/lib/i18n';
import { assertDealLedgerEnabled } from './-utils/assertDealLedgerEnabled';
export const Route = createFileRoute('/_staff/deal/_list')({
  beforeLoad: assertDealLedgerEnabled,
  component: Layout
});
function Layout() {
  const {
    t
  } = useTranslation();
  return <div className="flex flex-col">
      <ProductHeader Logo={LogoDeal} name={t('pages.dealLedger.listPageTitle')} tabs={[]} type="resource" />
      <Outlet />
    </div>;
}